import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import RomaneioForm from '../components/romaneio/RomaneioForm';

const RomaneioNovo: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Novo Romaneio
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Cadastre um novo romaneio de saída e retorno de produtos
        </Typography>
      </Box>
      
      <RomaneioForm />
    </Container>
  );
};

export default RomaneioNovo;
